import { render, staticRenderFns } from "./CommentsBoxSingleField.vue?vue&type=template&id=732280dc"
import script from "./CommentsBoxSingleField.vue?vue&type=script&lang=js"
export * from "./CommentsBoxSingleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports